import { createDocument, setDocFolder } from './library';
import { listDocumentMeta } from './docMeta';
import {
  loadPeriodicSettings,
  periodicTemplate,
  periodicTitle,
  type Period,
  type PeriodicSettings,
} from './periodicNotes';

/**
 * Open the periodic note for a date, creating it if it does not exist.
 *
 * Idempotent by design: "open today" pressed twice must land in the same note,
 * not leave a trail of duplicates. Matching is by title, because the title *is*
 * the date — which is also why an existing note the user renamed away from the
 * pattern is correctly treated as a different note.
 */
export async function openPeriodicNote(
  period: Period,
  date: Date,
  open: (id: string) => Promise<void>,
  // The user's pattern and folder, falling back to the defaults.
  settings: PeriodicSettings = loadPeriodicSettings(period),
): Promise<void> {
  const title = periodicTitle(date, settings);
  const key = title.toLowerCase();

  const existing = (await listDocumentMeta()).find((d) => d.title.toLowerCase() === key);
  if (existing) {
    await open(existing.id);
    return;
  }

  const doc = await createDocument({
    title,
    content: periodicTemplate(date, period, title),
  });
  if (settings.folder) await setDocFolder(doc.id, settings.folder);
  await open(doc.id);
}
